<template>
  <!-- --------------- BEGIN Page Mes offres --------------- -->
  <div class="m-5 lg:m-15 2xl:m-20">
    <h3 class="mb-5 lg:mb-15 2xl:mb-20">
      Les offres Neopass
    </h3>
    <div class="grid grid-cols-3 gap-x-13 justify-items-center mx-15">
      <subscription-card 
        name="GRATUIT"
        description="(Sans engagement)"
        :details="['Filigrane sur PDF',
                   'Évaluation des compétences (Jusqu’à 2 historiques)',
                   'Recherche par Compétences',
                   'Plan d’Accompagnement Personnalisé',
                   'Préconisation Emploi/stage',
                   'Suivi des stages et mises à disposition',
                   'Frise chronologique',
                   'Bibliothèque de fiches de postes (Jusqu’à 10 FDP)',
                   'Cartographies individuelles / collectives (Jusqu’à 2 historiques)',
                   'Support client mail uniquement']"
        :is-current="true"
        :price="0"
      />
        
      <subscription-card
        name="PILOTE"
        description="(12 mois sans engagement)"
        :details="['PDF sans filigrane',
                   'Évaluations des compétences (Illimitées)',
                   'Recherche par Compétences',
                   'Plan d’Accompagnement Personnalisé',
                   'Préconisation Emploi/stage',
                   'Suivi des stages et mises à disposition',
                   'Frise chronologique',
                   'Dépôt de documents',
                   'Bibliothèque de fiches de postes (Illimitées)',
                   'Cartographies individuelles / collectives (Illimitées)',
                   'Formation 2 jours en présentiel',
                   'Support client mail + tél',
                   'Suivi commercial']"
        :is-current="false"
        :price="3800"
      />

      <subscription-card
        name="EXPERT"
        description="(Engagement sur 24 mois)"
        :details="['Mode GRATUIT + PILOTE',
                   'Fonctionnalités illimitées',
                   'Personnalisation des formulaires d’évaluations',
                   'Formation 2 jours en présentiel',
                   'Formation visio personnalisée (Jusqu’à 6h/an)',
                   'Support client mail + tél',
                   'Suivi commercial']"
        :is-current="false"
        :price="8800"
      />
    </div>
  </div>
  <!-- --------------- END Page Mes offres --------------- -->
</template>

<script>
import axios from './../../api';
import store from './../../store';
import { mapGetters, mapMutations } from 'vuex';
import SubscriptionCard from './Subscription/SubscriptionCard.vue';

export default {
  name: 'SubscriptionChoice',

  components: {
    SubscriptionCard,
  },

  data() {
    return {
      /* BEGIN datas for "mes abonnements" */
      subscription: {},

      priceUnit: 9.9,
      nbNeopass: 1,

      selectedPlan: '',

      volumeNeopass: {
        total: 0,
        created: 0,
        active: 0,
        inactive: 0,
        suspended: 0,
        available: 0,
      },
      /* END datas for "mes abonnements" */
    };
  },

  mounted() {
    this.loadSubscription();
  },

  methods: {
    ...mapMutations({
      SET_TABDISPLAY: 'account/SET_TABDISPLAY',
      SET_SAVING: 'account/SET_SAVING',
    }),

    loadSubscription() {
      store.commit('app/SET_LOADING', true);
      axios.get('/api/subscription/subscription').then((response) => {
        this.nbNeopass = 0;
        if (response.data && response.data.length > 0) {
          //if subscription exists
          this.subscription = response.data;

          //perhaps have multi subscriptions
          this.subscription.forEach((sub) => {
            if (sub.quantity > 0) {
              this.nbNeopass += sub.quantity;
            }
          });
          store.commit('auth/SET_SUBSCRIPTION', this.subscription[0]);
        }
        if (this.nbNeopass > 0 && this.nbNeopass <= 100) {
          this.selectedPlan = 'standard';
        } else if (this.nbNeopass > 100) {
          this.selectedPlan = 'plus';
        } else {
          this.selectedPlan = 'gratuit';
        }
        store.commit('app/SET_LOADING', false);
      });
      store.commit('app/SET_LOADING', false);
    },

    cancelSubscription() {
      if (this.isAdminPay) {
        store.commit('app/SET_LOADING', true);
        axios.post('/api/subscription/cancel-subscription').then(() => {
          this.loadSubscription();
          this.SET_TABDISPLAY('abonnements');
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      isAdminPay: 'account/isAdminPay',
      tab_display: 'account/tabDisplay',
      saving: 'account/saving',
    }),
  },
};
</script>
